import React from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import axios from 'axios';
import { MultiSelect } from 'primereact/multiselect';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import MenubarView from './MenubarView';
import { useEffect, useState,useRef } from 'react';
import { FilterMatchMode } from 'primereact/api';
import { ContextMenu } from 'primereact/contextmenu';
import { Dialog } from 'primereact/dialog';
import { PrimeIcons } from 'primereact/api';
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from "react-router";

const ImportView = (props) => {
    const toast = useRef(null);
    const cm = useRef(null);
    const menuModel = [
        { label: '', icon: PrimeIcons.PLUS }
    ];
    const [selectedEntry, setSelectedEntry] = useState(null);
    const uploadServer = '/v1/importfile'
    const [entries, setEntries] = useState(null);
    const [selectedEntries, setSelectedEntries] = useState(null);
    const [categories,setCategories] = useState(null);
    const [categoriesWithIds,setCategoriesWithIds] = useState(null)
    const [ownersWithIds,setOwnersWithIds] = useState(null);
    const statuses = ['true', 'false'] 
    const [filters,setFilters] = useState({
        categoryname: { value: null, matchMode: FilterMatchMode.IN },
        imported: { value: ['false'] , matchMode: FilterMatchMode.IN },
        amount: { value: null, matchMode: FilterMatchMode.EQUALS },
        description: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
    const [keywordDialog,setKeywordDialog] = useState(false);
    const [keywordEntry, setKeywordEntry] = useState({
        id:null,
        categoryid: null,
        categoryname:null,
        name: null
    });

    const navigate  = useNavigate()
    if (localStorage.getItem('adminAccess') !== 'true')  
        navigate('/unauthorized')


    useEffect(() => {
        fetchCategoryData()
        fetchOwnerData()
    }, [])

    const fetchCategoryData = () => {
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        }
        const url =   '/v1/categoryentries' 
        axios.get(url,config)
        .then(response => {
            setCategoriesWithIds(response.data)
            const arr = [];
            for(var i in response.data)
                arr.push(response.data[i].name)
            setCategories(arr)
        })  
    }

    const fetchOwnerData = () => {
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        }
        const url =   '/v1/ownerentries'; 
        axios.get(url,config)
        .then(response => {
            setOwnersWithIds(response.data)
        })  
    }

    const onRowEditComplete = (e) => {
        setEntries((prevEntries) =>
            prevEntries.map((item) =>
                item.id === e.newData.id ? { ...item, categoryname: e.newData.categoryname } : item
            )
        );
    };

    const categoryEditor = (options) => {
        return (
            <Dropdown
                value={options.value}
                options={categories}
                filter
                onChange={(e) => {
                    options.editorCallback(e.value)
                }}
            />
        );
    };
    
    const reset = () => {
        setFilters({
            categoryname: { value: null, matchMode: FilterMatchMode.IN },
            imported: { value: null , matchMode: FilterMatchMode.IN },
            amount: { value: null, matchMode: FilterMatchMode.EQUALS },
            description: { value: null, matchMode: FilterMatchMode.CONTAINS }
        })
    }

    const hideDialog = () => {
        setKeywordDialog(false);
        setKeywordEntry({id:null,
            categoryid: null,
            categoryname:null,
            name: null
        })
    }
    
    const onUpload = (e) => {
        setEntries(null);
        //toast.current.show({ severity: 'info', summary: 'Success', detail: e.files[0].name + ' (' +e.files[0].size + ' bytes) '+ ' uploaded' });
        console.log(e.xhr.response)
        const parsed = JSON.parse(e.xhr.response);
        const uniqueEntries = Array.isArray(parsed)
            ? parsed.map((item, idx) => ({ ...item, id: idx + 1 }))
            : [];
        setEntries(uniqueEntries);
    }
    
    const ownerBodyTemplate = (rowData) => {
        return (<div>{rowData.ownername}</div>);
    };

    

    const categoryBodyTemplate = (rowData) => {
        return (<div>{rowData.categoryname}</div>);
    };


    const categoryFilterTemplate = (options) => {
        return (
            <MultiSelect
                value={options.value}
                options={categories}
                onChange={(e) => options.filterApplyCallback(e.value)}
                filter
                placeholder="Select Category"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
            />
        );
    };

    const importedBodyTemplate = (rowData) => {
        return (<div>{rowData.imported}</div>);
    };


    const importedFilterTemplate = (options) => {
        return (
            <MultiSelect
                value={options.value}
                options={statuses}
                onChange={(e)=>options.filterApplyCallback(e.value)}
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
            />
        );
    };

    const dateBodyTemplate = (rowData) => {
       return rowData.date.substring(0, 10);
    }

    const getCategoryId = (name) => {
        let result  = '';
        categoriesWithIds.forEach(item => {
            if (item.name === name) result=item.id;});
        return result;
    };

    const getOwnerId = (name) => {
        let result  = ''
        ownersWithIds.forEach(item => {
            if (item.name === name) result = item.id
        });
        return result
    };

    const importEntries = () => {
        if (!selectedEntries || selectedEntries.length === 0) return;
        const selectedIds = new Set(selectedEntries.map((entry) => entry.id));

        selectedEntries.forEach((entry)=> {
            var date = entry.date.substring(6,10) + '-' + entry.date.substring(0,2) + '-' + entry.date.substring(3,5)
            let body = 'actualdate=' + date + '&ownerid=' + getOwnerId(entry.ownername) + '&categoryid=' + getCategoryId(entry.categoryname) + '&amount=' + entry.amount + '&description=' + encodeURIComponent(entry.description.replaceAll('&',' '))
            const token = localStorage.getItem('bearerToken')
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            }
            let uri = '/v1/addcashentry'
            axios.post(uri,body,config)
                .then(function (response) {
                    entry.cashentryId = response.data.insertId
                })
                .catch(err => console.warn(err))
        });

        setEntries((prevEntries) =>
            prevEntries.map((item) =>
                selectedIds.has(item.id) ? { ...item, imported: 'true' } : item
            )
        );
        setSelectedEntries(null);
    }
 
    const addKeywordEntry  = () => {
       
        let body = '&categoryid=' + keywordEntry.categoryid + '&name=' + keywordEntry.name;
        let uri =   '/v1/addkeywordentry';

        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        }
        axios.post(uri,body,config)
            .then(function (response) {
            keywordEntry.id = response.data.insertId;
            })
            .catch(err => console.warn(err));
        hideDialog()
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Entry Created ', life: 3000 });
        

    }

    const showKeywordEntryDialog = (e) => {
        console.log(e.description)
        setKeywordEntry({...keywordEntry,name:e.description})
        setKeywordDialog(true)
        

    }

    const keywordDialogFooter = () => {   
        return (
        <React.Fragment>
             <Toast ref={toast}></Toast>
             <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
             <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={addKeywordEntry} />
         </React.Fragment>
        );
     }
 

    const onBeforeUploadSend = (e) => {
        const token = localStorage.getItem('bearerToken');
        if (token) {
            e.xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        }
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="p-mr-2">
                        <Toast ref={toast}></Toast>
                        <FileUpload mode="basic" name="uploadFile" url={uploadServer} accept=".csv" maxFileSize={5000000} onBeforeSend={onBeforeUploadSend} onUpload={onUpload} auto chooseLabel="Import File" />
                </div>
                <Button label="Clear" className="p-button-outlined p-mr-2" icon="pi pi-filter-slash" onClick={reset} />
                <Button label="Uploaded Selected Entries" icon="pi pi-upload" iconPos="right" onClick={importEntries} />
     
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        <React.Fragment>
            <Button label="Uploaded Selected Entries" icon="pi pi-upload" iconPos="right" onClick={reset} />
        </React.Fragment>
    }

    return (
        <>  
            <div><MenubarView/></div>
            <Toolbar className="p-mb-2" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>
            <div className="card p-fluid">
                <Toast ref={toast} />
                <ContextMenu model={menuModel} ref={cm} onHide={() => setSelectedEntry(null)} />

                <DataTable  value={entries} editMode="row" dataKey="id" filters={filters} filterDisplay="row" paginator rows={50}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[50,75,100]} loadingIcon="../public/logo512.png"
                    onRowEditComplete={onRowEditComplete} selection={selectedEntries}  onSelectionChange={(e) => 
                    setSelectedEntries(e.value)} tableStyle={{ minWidth: '50rem' }} emptyMessage="No records found."
                    onContextMenu={(e) => cm.current.show(e.originalEvent)} contextMenuSelection={selectedEntry} 
                    onContextMenuSelectionChange={(e) => {
                        showKeywordEntryDialog(e.value)
                    }}>
                    <Column selectionMode="multiple" headerStyle={{minWidth:'3rem'}}></Column>
                    <Column rowEditor headerStyle={{ width:'10%', minWidth:'7rem'}} bodyStyle={{ textAlign: 'center' }}></Column>
                    <Column field="id" header="ID" sortable></Column>
                    <Column header="DATE" field="date" dataType="date" body={dateBodyTemplate} style={{ minWidth: '14rem' }} sortable></Column>
                    <Column header="AMOUNT" field="amount"  dataType="numeric" filter filterPlaceholder="Search by Amount" sortable style={{ minWidth: '14rem' }}></Column>
                    <Column header="DESCRIPTION" field="description" filter filterPlaceholder="Search by Description" style={{ width: '30%' }} sortable></Column>
                    <Column header="IMPORTED?" field="imported" filterField="imported" dataType='boolean' showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '14rem' }}
                    body={importedBodyTemplate} filter filterElement={importedFilterTemplate} />
                    <Column header="CATEGORY" field="categoryname" filterField="categoryname" showFilterMenu={false} sortable filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '14rem' }}
                    body={categoryBodyTemplate} filter filterElement={categoryFilterTemplate} editor={categoryEditor} />
                    <Column header="ACCOUNT" field="ownername" sortable style={{ minWidth: '14rem' }} body={ownerBodyTemplate} />
                </DataTable>
            </div>
            <div>
            <Dialog visible={keywordDialog} style={{ width: '600px'}} header="Keyword Entry" modal  footer={keywordDialogFooter} onHide={hideDialog}> 
                <div className="p-field p-col-12 p-md-48">
                    <span className="p-float-label">
                        <Dropdown id="keywordDialogCategoryField" style={{'text-align':'left', 'minWidth': '14rem'}} value={keywordEntry.categoryname} options={categories} 
                        onChange={
                            (e) => setKeywordEntry({...keywordEntry,categoryid: getCategoryId(e.target.value),categoryname: (e.target.value)})
                        }
                        />
                        <label htmlFor="keywordDialogCategoryField">Select Category</label>
                    </span>
                </div>
                <div className="p-field p-col-12 p-md-24">
                    <span className="p-float-label">
                    <InputTextarea id="keywordDialogNameField" value={keywordEntry.name} onChange={(e) => setKeywordEntry({...keywordEntry,name:e.target.value})} rows={16} cols={40} />
                    <label htmlFor="keywordDialogNameField">Enter Keyword</label>
                    </span>
                </div>
                <div className="p-field p-col-12 p-md-24">
                    <span className="p-float-label">
                           
                    </span>
                </div>
            </Dialog>
            </div>
        </>
    );
}
export default  ImportView;